import React from 'react';
import SmallLoading from "../SmallLoading";
import {useTranslation} from "react-i18next";

interface IButton {
    onClick: any
    value?: string
    conditionalClassName: string
    networkLoading?: boolean
}

const Button: React.FC<IButton> = ({onClick, value = 'continue', conditionalClassName = '', networkLoading}) => {
    const {t} = useTranslation()
    return (
        <button

            onClick={onClick}
            className={`${conditionalClassName} cursor-pointer text-white h-12 font-bold py-2 px-12 rounded-full mx-auto block my-3.5 w-full`}>

                <span className="flex items-center justify-center ml-2">
                    {t(value)}
                    {
                        networkLoading && <SmallLoading borderRightColor={'deepskyblue'}/>
                    }
                </span>
            {/*{t(value)}*/}
            {/*{networkLoading && (*/}
            {/*    <span className="flex items-center justify-center ml-2">*/}
            {/*        <SmallLoading/>*/}
            {/*    </span>*/}
            {/*)}*/}
        </button>
    )
}
export default Button